import { render } from "./AdminConsole.vue?vue&type=template&id=1e155e62"
import script from "./AdminConsole.vue?vue&type=script&lang=js"
export * from "./AdminConsole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__